import { useRealtyApp } from '@strana-artw/realty';
import { setActivePinia } from 'pinia';

import type { Context } from '@nuxt/types';

const piniaPlugin = ({ $pinia, app }: Context): void => {
  $pinia.use(({ store }: { store: any }) => {
    store.$router = app.router;
    store.$sentry = app.$sentry;
    store.$notify = app.$notify;
  });

  setActivePinia($pinia);
  useRealtyApp();
};

export default piniaPlugin;
